module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"payTitulo":"Powershop","payTtl":"El software para tiendas que mejor se adapta tu empresa.","payText":" ","payBtn":"MÁS INFORMACIÓN"},"es":{"payTitulo":"Powershop","payTtl":"El software para tiendas que mejor se adapta tu empresa.","payText":" ","payBtn":"MÁS INFORMACIÓN"}}')
  delete Component.options._Ctor
}
